/**
 * Mag set top box new api polyfill for stbAudioManager
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint-disable*/

var gSTB = window.parent.gSTB,
    stbAudioOutput;

if ( window.parent.stbAudioManager ) {
    module.exports = window.parent.stbAudioManager;
} else {
    stbAudioOutput = {
        /**
         * An object linked with this audio output.
         *
         * By default player #0 is linked with audio output #0.
         *
         * @type {stbPlayer[]}
         *
         * @example
         * // get audio output #1 instance
         * var output = stbAudioManager.list[1];
         * // get audio source #0
         * output.list[0];
         */
        list: [],


        add: function ( source ) {},


        remove: function ( source ) {},


        clear: function () {}
    };

    Object.defineProperties(stbAudioOutput, {
        /**
         * Master mute state of audio output.
         *
         * After the cycle of switching off/on with this property the volume level remains unchanged.
         *
         * @type {boolean}
         */
        mute: {
            get: function () {
                return !!gSTB.GetMute();
            },
            set: function ( value ) {
                gSTB.SetMute(!!value);
            }
        },

        /**
         * Master volume level in percents (0 - no sound, 100 - maximal level).
         *
         * @type {number}
         */
        volume: {
            get: function () {
                return gSTB.GetVolume();
            },
            set: function ( value ) {
                gSTB.SetVolume(+value);
            }
        }
    });

    module.exports = {
        /**
         * Get array of all available stbAudioOutput instances in the system.
         *
         * @type {stbAudioOutput[]}
         * @readonly
         *
         * @example
         * // get audio output #1 instance
         * var output = stbAudioManager.list[1];
         * // and link it with a player
         * output.source = stbPlayerManager.list[1];
         */
        list: [stbAudioOutput]
    };
}
